import startCase from 'lodash-es/startCase';
import { string, number, object } from 'yup';

export const NEST_SEPARATOR = '--';

function generateValues(type, first, second, key, values, schemaKeys) {
  const diff = Number(second) - Number(first);
  const operator = diff >= 0 ? '+' : '-';

  values[`${key}${NEST_SEPARATOR}${type}${NEST_SEPARATOR}first`] = first;
  values[`${key}${NEST_SEPARATOR}${type}${NEST_SEPARATOR}second`] = Math.abs(
    diff
  );
  values[`${key}${NEST_SEPARATOR}${type}${NEST_SEPARATOR}field`] = operator;
  values[`${key}${NEST_SEPARATOR}${type}${NEST_SEPARATOR}value`] = second;

  schemaKeys.push(`${key}${NEST_SEPARATOR}${type}${NEST_SEPARATOR}second`);
  schemaKeys.push(`${key}${NEST_SEPARATOR}${type}${NEST_SEPARATOR}field`);
}

export function convertPriceTimeArray(firstData, secondData, sectionkey) {
  const { price: firstPrice, time: firstTime } = firstData || {
    price: [],
    time: []
  };
  const { price: secondPrice, time: secondTime } = secondData || {
    price: [],
    time: []
  };

  let maxBedrooms = 5;
  if (firstPrice && firstPrice.length > maxBedrooms) {
    maxBedrooms = firstPrice.length;
  }

  if (secondPrice && secondPrice.length > maxBedrooms) {
    maxBedrooms = secondPrice.length;
  }

  const values = {};
  const schemaKeys = [];
  const labels = [];

  for (let i = 0; i < maxBedrooms; i += 1) {
    const firstPriceVal = firstPrice[i] || 0;
    const secondPriceVal = secondPrice[i] || 0;
    const firstTimeVal = firstTime[i] || 0;
    const secondTimeVal = secondTime[i] || 0;
    const groupKey = `${sectionkey}${NEST_SEPARATOR}${i}_bedrooms`;

    labels.push({
      label: `${i} bedrooms`,
      groupKey
    });

    generateValues(
      'price',
      firstPriceVal,
      secondPriceVal,
      groupKey,
      values,
      schemaKeys
    );
    generateValues(
      'time',
      firstTimeVal,
      secondTimeVal,
      groupKey,
      values,
      schemaKeys
    );
  }

  return {
    schemaKeys,
    values,
    labels,
    sectionkey
  };
}

export function convertPriceTimeObject(firstData, secondData, sectionkey) {
  const firstObject = firstData || {};
  const secondObject = secondData || {};

  const firstKeys = Object.keys(firstObject);
  const secondKeys = Object.keys(secondObject);

  let targeKeys = firstKeys.length < secondKeys.length ? secondKeys : firstKeys;

  const values = {};
  const schemaKeys = [];
  const labels = [];

  targeKeys.forEach(itemKey => {
    const groupKey = `${sectionkey}${NEST_SEPARATOR}${itemKey}`;

    const firstItem = firstObject[itemKey] || {};
    const secondItem = secondObject[itemKey] || {};

    const firstPriceVal = firstItem.price || 0;
    const secondPriceVal = secondItem.price || 0;
    const firstTimeVal = firstItem.time || 0;
    const secondTimeVal = secondItem.time || 0;

    labels.push({
      label: startCase(itemKey),
      groupKey
    });

    generateValues(
      'price',
      firstPriceVal,
      secondPriceVal,
      groupKey,
      values,
      schemaKeys
    );
    generateValues(
      'time',
      firstTimeVal,
      secondTimeVal,
      groupKey,
      values,
      schemaKeys
    );
  });

  return {
    schemaKeys,
    values,
    labels,
    sectionkey
  };
}

export function mergeSections(sectionSchemas) {
  let totalValues = {};
  let totalSchemas = {};
  const sections = [];
  sectionSchemas.forEach(section => {
    const { schemaKeys, values, labels, sectionkey } = section;
    totalValues = {
      ...totalValues,
      ...values
    };

    schemaKeys.forEach(item => {
      const last5 = item.slice(item.length - 5, item.length);

      if (last5 === 'field') {
        schemaKeys[item] = string().required('Please provide value');
        return;
      }

      schemaKeys[item] = number('Please provide number').required(
        'Please provide value'
      );
    });

    sections.push({
      sectionkey: sectionkey,
      title: sectionkey !== 'addons' ? startCase(sectionkey) : '',
      labels
    });
  });

  return {
    initialValues: totalValues,
    validationSchema: object().shape(totalSchemas),
    sections
  };
}

function safeGet(obj, key, isArray) {
  if (!obj[key]) {
    if (isArray) {
      obj[key] = [];
    } else {
      obj[key] = {};
    }
  }
  return obj[key];
}

const DEFAULT_MAIN_KEYS = ['addons', 'deep-clean', 'hotel-style'];

export function buildValues(formValues, mainKeys = DEFAULT_MAIN_KEYS) {
  const schemaKeys = Object.keys(formValues);
  const values = {};

  schemaKeys.forEach(itemKey => {
    const [sectionkey, groupKey, type, fieldType] = itemKey.split(
      NEST_SEPARATOR
    );
    if (fieldType !== 'value') {
      return;
    }
    const value = formValues[itemKey];
    let target = values;
    if (!mainKeys.includes(sectionkey)) {
      target = safeGet(target, 'specialServices');
    }
    target = safeGet(target, sectionkey);
    const isArray = groupKey.endsWith('bedrooms');
    if (isArray) {
      target = safeGet(target, type, isArray);
      target.push(value);
    } else {
      target = safeGet(target, groupKey);
      target[type] = value;
    }
  });

  return values;
}
